import { makeStyles } from '@material-ui/core';
import { DOCUMENTS_GRID_MODAL_CONTENT_HEIGHT } from './constants';

export const useDocumentsGridStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: DOCUMENTS_GRID_MODAL_CONTENT_HEIGHT,
        width: '100%',
        overflow: 'auto',
        position: 'relative',
        paddingRight: 4,
    },
    itemContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        gap: '1rem',
        width: '100%',
        flex: 1,
    },
    itemContainerCentered: {
        justifyContent: 'center',
    },
    itemContainerLeft: {
        justifyContent: 'flex-start',
    },
    itemWrapper: {
        flex: '1 1 280px',
        maxWidth: '100%',
        minWidth: 0,
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 'calc(50% - 0.5rem)',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(33.333% - 0.67rem)',
        },
        '& > *': {
            width: '100%',
        },
    },
    itemWrapperSingle: {
        [theme.breakpoints.up('sm')]: {
            maxWidth: 'calc(50% - 0.5rem)',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(33.333% - 0.67rem)',
        },
    },
    emptyState: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
}));

export const useDocumentsGridItemStyles = makeStyles((theme) => ({
    card: {
        position: 'relative',
        backgroundColor: 'rgba(128, 128, 128, 0.3)',
        cursor: 'pointer',
        transition: 'opacity 0.2s ease',
        '&:hover': {
            opacity: 0.85,
        },
        [theme.breakpoints.up('sm')]: {
            display: 'grid',
            gridTemplateRows: 'auto 1fr',
        },
        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: theme.spacing(1.5),
            padding: theme.spacing(1.5, 0),
            borderBottom: `1px solid ${theme.palette.divider}`,
            backgroundColor: 'transparent',
            borderRadius: 0,
            boxShadow: 'none',
        },
    },
    cardSelected: {
        boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
    },
    selectionBadge: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
        zIndex: 1,
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        lineHeight: 0,
    },
    imageBox: {
        overflow: 'hidden',
        backgroundColor: theme.palette.grey[200],
        [theme.breakpoints.up('sm')]: {
            height: 200,
        },
        [theme.breakpoints.down('xs')]: {
            width: 72,
            height: 72,
            flexShrink: 0,
            borderRadius: theme.shape.borderRadius,
        },
    },
    imageBoxInteractive: {
        cursor: 'zoom-in',
    },
    image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    },
    filePreview: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.secondary,
    },
    content: {
        [theme.breakpoints.down('xs')]: {
            padding: 0,
            flex: 1,
            minWidth: 0,
            '&:last-child': {
                paddingBottom: 0,
            },
        },
    },
    title: {
        wordWrap: 'break-word',
    },
    secondaryText: {
        fontSize: 14,
        wordWrap: 'break-word',
        color: theme.palette.text.secondary,
    },
}));

export const useDocumentsGridSkeletonStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        gap: '1rem',
        width: '100%',
        height: '100%',
        overflow: 'auto',
        paddingRight: 4,
    },
    itemWrapper: {
        flex: '1 1 280px',
        maxWidth: '100%',
        minWidth: 0,
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 'calc(50% - 0.5rem)',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(33.333% - 0.67rem)',
        },
        '& > *': {
            width: '100%',
        },
    },
    card: {
        backgroundColor: 'rgba(128, 128, 128, 0.15)',
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
    },
    imageSkeleton: {
        height: 200,
    },
    content: {
        padding: theme.spacing(2),
    },
}));
